import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import { styled } from '@linaria/react';
import { memo } from 'react';

const View = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  item-align: center;
  justify-content: flex-start;
`;

const CalendarSkeleton = () => {
  return (
    <View>
      <RectangleSkeleton width={26} height={26} style={{ marginRight: '8px' }}/>
      <RectangleSkeleton width={100} height={24} />
    </View>
  );
};

export default memo(CalendarSkeleton);
